var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEnlightenment = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 81 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 40.5C8 22.55 22.55 8 40.5 8S73 22.55 73 40.5 58.45 73 40.5 73 8 58.45 8 40.5ZM40.5 0C18.133 0 0 18.133 0 40.5c0 18.57 12.498 34.22 29.542 39H9a4 4 0 0 0 0 8h64a4 4 0 0 0 0-8H51.458C68.502 74.72 81 59.07 81 40.5 81 18.133 62.867 0 40.5 0Z",
  fill: "#1380FF"
})));

export default SvgEnlightenment;